<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            v-model="insuranceService.show"
            @hidden="$emit('clearInsurance')" 
            hide-footer
        >
        <template slot="modal-title">
            <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-12">
                <h3 class="mb-0">{{(switchModal === 'select')?'เลือกประกันที่ต้องการใช้งาน':'ประกันเสริม'}}</h3>
                </div>
            </div>
            </div>
        </template>
        <card shadow type="secondary" class="m--4">
            <template v-if="switchModal === 'select'">
                <form @submit.prevent>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="group-result">
                                <div class="price">
                                    <div class="col-lg-3">
                                        <h6>เลือกประกัน</h6>
                                    </div>
                                    <div class="col-lg-9">
                                        <v-select
                                            class="w-100"
                                            placeholder="เลือกประกันที่ต้องการสมัคร"
                                            label="name"
                                            :options="insurance"
                                            v-model="insuranceService.insurance"
                                            @input="selectInsurance"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="px-lg-5 py-lg-5 text-center">
                                <template v-if="insuranceService.insurance !== null && insuranceCondition.status == true && insuranceCondition.confirm == true">
                                    <h4>กรุณาสแกน QR CODE ด้วย สมาร์ทโฟน</h4>
                                    <img class="image-hover py-2" :src="insuranceService.insurance.qrCode" alt="qrcode" width="250" height="250">
                                    <div class="pt-2">
                                        หรือ
                                        <div class="pt-2">
                                            <a class="btn btn-info" :href="insuranceService.insurance.link" target="_blank">
                                                เปิดบนเว็บเบราว์เซอร์
                                            </a>
                                        </div>
                                        <div class="pt-lg-4">
                                            <a :href="linkManual" target="_blank" class="px-1">
                                                อ่านคู่มือการใช้งาน
                                            </a>
                                            <!-- <a :href="linkTeach" target="_blank" class="px-1">
                                                ดูวีดีโอสอนใช้งาน
                                            </a> -->
                                            <a :href="linkPolicy" target="_blank">
                                                รายละเอียดแต่ละกรมธรรม์
                                            </a>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <h3 class="text-muted py-lg-5">กรุณาเลือกประกันที่จะสมัคร</h3>
                                    <div class="pt-lg-4">
                                        <a :href="linkManual" target="_blank" class="px-1">
                                            อ่านคู่มือการใช้งาน
                                        </a>
                                        <!-- <a :href="linkTeach" target="_blank" class="px-1">
                                            ดูวีดีโอสอนใช้งาน
                                        </a> -->
                                        <a :href="linkPolicy" target="_blank">
                                            รายละเอียดแต่ละกรมธรรม์
                                        </a>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <hr class="my-4" />
                    </div>
                    <div class="mt-4 w-100 text-right">
                        <b-button variant="secondary" @click="$emit('clearInsurance')">ปิด</b-button>
                        <b-button type="submit" variant="success" :disabled="!insuranceService.insurance" @click="switchModal = 'pay'">ยืนยัน</b-button>
                    </div>
                </form>
            </template>
            <template v-else>
                <form @submit.prevent>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="group-result">
                                <div class="price">
                                    <div class="col-lg-5 text-left">
                                        <h6>เลือกบริการประกันภัย</h6>
                                    </div>
                                    <div class="col-lg-7">
                                        <v-select
                                            class="'w-100'"
                                            placeholder="เลือกประกันที่ต้องการสมัคร"
                                            label="name"
                                            :options="insurance"
                                            v-model="insuranceService.insurance"
                                            disabled="disabled"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4" />
                            <div class="group-result">
                                <div class="price">
                                    <div class="col-lg-5 text-left">
                                        <h6>จำนวนเงิน</h6>
                                    </div>
                                    <div class="col-lg-7 text-right">
                                        <h1>
                                            {{( Number(insuranceService.insurance.rate) ) | numFormat('0,0.00')}}
                                            <small>บาท</small>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4" />
                            <div class="group-result">
                                <div class="price">
                                    <div class="col-lg-5 text-left">
                                         <h6>ยอดสุทธิ</h6>
                                    </div>
                                    <div class="col-lg-7 text-right">
                                        <h1>
                                            {{( Number(insuranceService.insurance.rate) ) | numFormat('0,0.00')}}
                                            <small>บาท</small>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4" />
                        </div>
                    </div>
                    <div class="mt-4 w-100 text-right">
                        <b-button variant="secondary" @click="$emit('clearInsurance')">ยกเลิก</b-button>
                        <b-button type="submit" variant="success" @click="$emit('addInsurance')">ยืนยัน</b-button>
                    </div>
                </form>
            </template>
        </card>
        </b-modal>
        <ModalCondition 
            :insuranceCondition="insuranceCondition" 
        />
    </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ModalCondition from '@/components/Modals/ModalCondition'
export default {
    name: "ModalInsurance" ,
    props: {
        insuranceService: Object,
        submitAddInsurance: Boolean,
    },
    components:{
        ModalCondition
    },
    data() {
        return {
            insurance: [
                // {name: 'สินมั่นคงประกันภัย 199 บาท', qrCode: require('../../assets/images/insurance-smk.png'), link: 'https://everydayinsure.typeform.com/to/u6UezJ0z', rate:'199', code:'smk'},
                // {name: 'สินมั่นคงประกันภัย 399 บาท', qrCode: require('../../assets/images/insurance-smk.png'), link: 'https://everydayinsure.typeform.com/to/u6UezJ0z', rate:'399', code:'smk'},
                {name: 'ทิพยประกันภัย 450 บาท', qrCode: require('../../assets/images/insurance-dpy.png'), link: 'https://everydayinsure.com/Module/Covid/Covid19.aspx', rate:'450', code:'dpy'},
                {name: 'ทิพยประกันภัย 850 บาท', qrCode: require('../../assets/images/insurance-dpy.png'), link: 'https://everydayinsure.com/Module/Covid/Covid19.aspx', rate:'850', code:'dpy'},
                // {name: 'อาคเนย์ 369 บาท', qrCode: require('../../assets/images/insurance-dpy.png'), link:'https://everydayinsure.com/Module/Covid/Covid19.aspx', rate: 369,  code:'seic'},
                // {name: 'อาคเนย์ 639 บาท', qrCode: require('../../assets/images/insurance-dpy.png'), link:'https://everydayinsure.com/Module/Covid/Covid19.aspx', rate: 639,  code:'seic'},
                // {name: 'อาคเนย์ 799 บาท', qrCode: require('../../assets/images/insurance-dpy.png'), link:'https://everydayinsure.com/Module/Covid/Covid19.aspx', rate: 799,  code:'seic'},
                // {name: 'อาคเนย์ 1,369 บาท', qrCode: require('../../assets/images/insurance-dpy.png'), link:'https://everydayinsure.com/Module/Covid/Covid19.aspx', rate: 1369,  code:'seic'}
                
            ],
            linkManual:"https://docs.google.com/presentation/d/1s0vRXAe77HFh5J3uWyQ90dI_PYj02K9YzkBNIUcsFVM/edit?usp=sharing",
            linkTeach:"https://www.youtube.com/watch?v=8UVvQqDTpng",
            linkPolicy:"https://drive.google.com/drive/u/1/folders/1bv93B-HNuU7CXlFLa1nLl43XlV70tWsv",
            switchModal: 'select',
            insuranceCondition:{
                show: false,
                status: false,
                type: '',
                confirm: false
            }
        }
    },
    mounted() {
        const seicList = [
            {name: 'เอเชียประกันภัย 365 บาท', qrCode: require('../../assets/images/insurance-dpy.png'), link: 'https://everydayinsure.com/Module/Covid/Covid19.aspx', rate:'365', code:'asia'},
            {name: 'เอเชียประกันภัย 500 บาท', qrCode: require('../../assets/images/insurance-dpy.png'), link: 'https://everydayinsure.com/Module/Covid/Covid19.aspx', rate:'500', code:'asia'},
            {name: 'เอเชียประกันภัย 1,825 บาท', qrCode: require('../../assets/images/insurance-dpy.png'), link: 'https://everydayinsure.com/Module/Covid/Covid19.aspx', rate:'1825', code:'asia'},
        ];
        if (new Date().getTime() < new Date('2021-06-30 00:00:00').getTime()) {
            seicList.map((item) => {
                this.insurance.push(item)
            })
        }
    },
    methods: {
        selectInsurance(){
            this.insuranceCondition.status = false;
            this.insuranceCondition.confirm = false;
            this.insuranceCondition.type = this.insuranceService.insurance.code
            this.insuranceCondition.show = true;
        }
    },
    computed: {
        
    }
}
</script>